import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'portal.components.coursesInProgress.title',
    defaultMessage: 'Modules In Progress',
    description: 'Default title for modules in progress section',
  },
  fiveDay: {
    id: 'portal.components.coursesInProgress.fiveDay.label',
    defaultMessage: '5 Day',
    description: '5 Day label',
  },
  challenge: {
    id: 'portal.components.coursesInProgress.challenge.label',
    defaultMessage: 'Challenge',
    description: 'Challenge label',
  },
  fiveDayChallenge: {
    id: 'portal.components.coursesInProgress.fiveDayChallenge.label',
    defaultMessage: '5 Day Challenge',
    description: '5 Day Challenge label',
  },
  calendarIconAlt: {
    id: 'portal.components.coursesInProgress.calendarIconAlt',
    defaultMessage: 'Calendar Icon',
    description: 'Calendar icon alt text',
  },
  timeLabel: {
    id: 'portal.components.coursesInProgress.time.label',
    defaultMessage: 'Time',
    description: 'Time label',
  },
  accessLabel: {
    id: 'portal.components.coursesInProgress.access.label',
    defaultMessage: 'Access',
    description: 'Access label',
  },
  complete: {
    id: 'portal.components.coursesInProgress.complete.label',
    defaultMessage: 'Complete',
    description: 'Complete label',
  },
  availableNow: {
    id: 'portal.components.coursesInProgress.availableNow.label',
    defaultMessage: 'Available Now',
    description: 'Available Now label',
  },
  completePreviousModule: {
    id: 'portal.components.coursesInProgress.completePreviousModule.label',
    defaultMessage: 'Complete Previous Module',
    description: 'Complete Previous Module label',
  },
});

export default messages;
